import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @title={{i18n "forgot_password.title"}}
  @closeModal={{@closeModal}}
  @flash={{this.flash}}
  @flashType="error"
  class="forgot-password-modal"
>
  <:body>
    {{#if this.offerHelp}}
      {{html-safe this.offerHelp}}
    {{else if this.siteSettings.hide_email_address_taken}}
      <label for="username-or-email">
        {{i18n "forgot_password.invite_no_username"}}
      </label>
      <input
        {{on "input" this.updateEmailOrUsername}}
        value={{this.emailOrUsername}}
        placeholder={{i18n "email"}}
        type="text"
        id="username-or-email"
        autocorrect="off"
        autocapitalize="off"
      />
    {{else}}
      <p>{{i18n "forgot_password.invite"}}</p>
      <label for="username-or-email">
        {{i18n "forgot_password.email-username"}}
      </label>
      <input
        {{on "input" this.updateEmailOrUsername}}
        value={{this.emailOrUsername}}
        placeholder={{i18n "login.email_placeholder"}}
        type="text"
        id="username-or-email"
        autocorrect="off"
        autocapitalize="off"
      />
    {{/if}}
  </:body>

  <:footer>
    {{#if this.offerHelp}}
      <DButton
        @action={{@closeModal}}
        @label="forgot_password.button_ok"
        type="submit"
        class="btn-large btn-primary"
      />
      {{#unless this.helpSeen}}
        <DButton
          @action={{this.help}}
          @label="forgot_password.button_help"
          @icon="question-circle"
          class="btn-large"
        />
      {{/unless}}
    {{else}}
      <DButton
        @action={{this.resetPassword}}
        @disabled={{this.submitDisabled}}
        @label="forgot_password.reset"
        type="submit"
        class="btn-primary forgot-password-reset"
      />
    {{/if}}
  </:footer>
</DModal>
*/
{
  "id": "0MVP7/tA",
  "block": "[[[8,[39,0],[[24,0,\"forgot-password-modal\"]],[[\"@title\",\"@closeModal\",\"@flash\",\"@flashType\"],[[28,[37,1],[\"forgot_password.title\"],null],[30,1],[30,0,[\"flash\"]],\"error\"]],[[\"body\",\"footer\"],[[[[1,\"\\n\"],[41,[30,0,[\"offerHelp\"]],[[[1,\"      \"],[1,[28,[35,3],[[30,0,[\"offerHelp\"]]],null]],[1,\"\\n\"]],[]],[[[41,[30,0,[\"siteSettings\",\"hide_email_address_taken\"]],[[[1,\"      \"],[10,\"label\"],[14,\"for\",\"username-or-email\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"forgot_password.invite_no_username\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[11,\"input\"],[16,2,[30,0,[\"emailOrUsername\"]]],[16,\"placeholder\",[28,[37,1],[\"email\"],null]],[24,1,\"username-or-email\"],[24,\"autocorrect\",\"off\"],[24,\"autocapitalize\",\"off\"],[24,4,\"text\"],[4,[38,4],[\"input\",[30,0,[\"updateEmailOrUsername\"]]],null],[12],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,2],[12],[1,[28,[35,1],[\"forgot_password.invite\"],null]],[13],[1,\"\\n      \"],[10,\"label\"],[14,\"for\",\"username-or-email\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"forgot_password.email-username\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[11,\"input\"],[16,2,[30,0,[\"emailOrUsername\"]]],[16,\"placeholder\",[28,[37,1],[\"login.email_placeholder\"],null]],[24,1,\"username-or-email\"],[24,\"autocorrect\",\"off\"],[24,\"autocapitalize\",\"off\"],[24,4,\"text\"],[4,[38,4],[\"input\",[30,0,[\"updateEmailOrUsername\"]]],null],[12],[13],[1,\"\\n    \"]],[]]]],[]]],[1,\"  \"]],[]],[[[1,\"\\n\"],[41,[30,0,[\"offerHelp\"]],[[[1,\"      \"],[8,[39,5],[[24,0,\"btn-large btn-primary\"],[24,4,\"submit\"]],[[\"@action\",\"@label\"],[[30,1],\"forgot_password.button_ok\"]],null],[1,\"\\n\"],[41,[51,[30,0,[\"helpSeen\"]]],[[[1,\"        \"],[8,[39,5],[[24,0,\"btn-large\"]],[[\"@action\",\"@label\",\"@icon\"],[[30,0,[\"help\"]],\"forgot_password.button_help\",\"question-circle\"]],null],[1,\"\\n\"]],[]],null]],[]],[[[1,\"      \"],[8,[39,5],[[24,0,\"btn-primary forgot-password-reset\"],[24,4,\"submit\"]],[[\"@action\",\"@disabled\",\"@label\"],[[30,0,[\"resetPassword\"]],[30,0,[\"submitDisabled\"]],\"forgot_password.reset\"]],null],[1,\"\\n\"]],[]]],[1,\"  \"]],[]]]]]],[\"@closeModal\"],false,[\"d-modal\",\"i18n\",\"if\",\"html-safe\",\"on\",\"d-button\",\"unless\"]]",
  "moduleName": "discourse/components/modal/forgot-password.hbs",
  "isStrictMode": false
});